import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
export class UitpasNumberAndPrice extends AutoEncoder {
    uitpasNumber;
    price;
    uitpasTariffId = null;
}
__decorate([
    field({ decoder: StringDecoder })
], UitpasNumberAndPrice.prototype, "uitpasNumber", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], UitpasNumberAndPrice.prototype, "price", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UitpasNumberAndPrice.prototype, "uitpasTariffId", void 0);
//# sourceMappingURL=UitpasNumberAndPrice.js.map